import { ContentViewStyle } from '@levelapp/softfabric';
import { StyleProp, ViewStyle } from 'react-native';

export default class ShellViewStyle extends ContentViewStyle
{
    shell: StyleProp<ViewStyle> = {
        display: 'flex',
        flex: 1,
    }
}